const SwithBtn = ({ label = " ", id, checked, onChange }) => {
  return (
    <>
      <div className="custom-control custom-switch">
        <input
          type="checkbox"
          className="custom-control-input"
          id={"switch-" + id}
          checked={checked}
          onChange={onChange}
        />
        {/**
         * La propiété label doit etre utiliser pour afficher le composant. Si on veut afficher
         * un libélé on ajoute la valeur sinon juste ajouter un espace.
         */}
        {label && (
          <label
            className="custom-control-label"
            htmlFor={"switch-" + id}
            style={{ cursor: "pointer" }}
          >
            {label}
          </label>
        )}
      </div>
    </>
  );
};

export default SwithBtn;
